import React from 'react';

export const SkeletonLinha: React.FC<{ largura?: string }> = ({ largura = '100%' }) => (
  <div className='mc-skeleton mc-skeleton--linha' style={{ width: largura }} />
);

export const SkeletonCard: React.FC = () => (
  <div className='mc-skeleton mc-skeleton--card'>
    <div className='mc-skeleton mc-skeleton--linha' style={{ width: '40%' }} />
    <div className='mc-skeleton mc-skeleton--linha' style={{ width: '70%' }} />
    <div className='mc-skeleton mc-skeleton--linha' style={{ width: '55%' }} />
  </div>
);

export const SkeletonTabela: React.FC<{ linhas?: number }> = ({ linhas = 5 }) => (
  <div className='mc-skeleton-tabela'>
    {Array.from({ length: linhas }).map((_, index) => (
      <div className='mc-skeleton mc-skeleton--linha' key={index} />
    ))}
  </div>
);
